/**
 * queryType
 * DYS  待一审
 * DSJCL  待商家处理
 * DMJCL  待买家处理
 * LS
 */
export enum ZdsRefundTabStatus {
  ALL = 'ALL',
  DYS = 'PENDING_FIRST_AUDIT',
  DSJCL = 'PENDING_BUYER',
  DMJCL = 'PENDING_SELLER',
  LS = 'COMPLETED'
}


export enum ZdsRefundStatus {
  PENDING_FIRST_AUDIT= 'PENDING_FIRST_AUDIT', // 待一审
  PENDING_BUYER = 'PENDING_BUYER', // 待买家处理
  PENDING_SELLER = 'PENDING_SELLER', // 待商家处理
  REFUNDING = 'REFUNDING', // 退款中
  COMPLETED = 'COMPLETED', // 已完成
  REFUNDING_FAIL = 'REFUNDING_FAIL' // 退款失败
}

// export const ZdsRefundStatusOptions = [
//   { label: '审核中', value: ZdsRefundStatus.YSZ },
//   { label: '审核驳回', value: ZdsRefundStatus.YJJ },
//   { label: '待用户寄回', value: ZdsRefundStatus.DJH },
//   { label: '用户寄回中', value: ZdsRefundStatus.THZ },
//   { label: '已退款', value: ZdsRefundStatus.YTK },
//   { label: '用户取消', value: ZdsRefundStatus.CANCEL },
// ]
